import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { IExportState, StateType } from '@/version-types';

/** 状态 */
interface IState {
    // 当前选中水印 id
    curFilter: string;
    // 水印 bridge 开启状态
    bridgeState: boolean;
    // 是否开启水印 bridge
    openWaterMarkBridge: boolean;
}

/** 动作 */
interface IAction {
    // 设置当前选中水印 id
    setCurFilter: (curFilter: string) => void;
    // 设置水印 bridge 开启状态
    setBridgeState: (bridgeState: boolean) => void;
    // 设置水印 bridge 开启
    setOpenWaterMarkBridge: (openWaterMarkBridge: boolean) => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 初始化状态 */
function getInitialState() {
    return {
        openWaterMarkBridge: false,
        bridgeState: false,
        curFilter: '',
    };
}

/** 创建存储 */
const createState = () => {
    const store = create<IStore>((set) => ({
        ...getInitialState(),

        setCurFilter(curFilter) {
            set({ curFilter });
        },
        setBridgeState(bridgeState) {
            set({ bridgeState });
        },
        setOpenWaterMarkBridge(openWaterMarkBridge) {
            set({ openWaterMarkBridge });
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'watermark-layer-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useWatermarkLayerState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getWatermarkLayerState = (editorIdentity: string) => {
    return getState<ModuleType>(editorIdentity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
